import { VFC, ReactNode } from 'react';
import classNames from 'classnames';
import './index.scss';

const PosterTime: VFC<{
  time: string | ReactNode;
  extra?: ReactNode | string;
  className?: string;
}> = ({ time, className, extra }) => (
  <div className={classNames('poster-time', className)}>
    {extra && <div className="poster-time-extra">{extra}</div>}
    <div className="poster-time-string">{time}</div>
  </div>
);

export default PosterTime;
